<template>
  <div id="login">
    <div class="login_box">
      <div class="login_cont" style="height:530px;">
        <div class="login_contRight right">
          <!--<div class="login_header">
            <p class="login_back" @click="goLogin">登录</p>
            <p class="register_back login_active">注册</p>
          </div>
          &lt;!&ndash; 注册 &ndash;&gt;
          <div class="login_footer register">
            <p style="margin-top: 30px;">
              <span>手机号</span>
              <input
                type="tel"
                maxlength="11"
                class="r_input1"
                style="width: 287px;"
                placeholder="请输入手机号"
                v-model="reName"
              >
            </p>
            <p>
              <span>登录密码</span>
              <input
                type="password"
                class="r_input2"
                placeholder="请输入登录密码"
                style="width: 287px;"
                v-model="rePass"
              >
            </p>
            <p>
              <span>图形验证码</span>
              <input
                type="text"
                placeholder="请输入图片验证码"
                style="width: 194px;"
                class="r_input3"
                v-model="rePicCode"
              >
              <s-identify
                class="login_img"
                :identifyCode="identifyCode"
                :contentWidth="95"
                :contentHeight="42"
                @refreshcode="getRePicCode"
              ></s-identify>
            </p>
            <p>
              <span>短信验证码</span>
              <input
                type="text"
                class="r_input4"
                placeholder="请输入短信验证码"
                style="width: 194px;"
                v-model="rePhoneCode"
              >
              <button
                v-bind:disabled="disabled"
                class="login_code"
                @click="getPhoneCode"
              >{{phoneCodeText}}</button>
            </p>
            <p>
              <span>推荐码(选填)</span>
              <input
                type="text"
                class="r_input5"
                v-model="rePhone"
                placeholder="请输入推荐码(选填)"
                style="width: 287px;"
              >
            </p>
            <div class="login_agree">
              <input type="checkbox" v-model="reAgree" >
              <span>我同意</span>
              <router-link :to="{name:'Protocol',params:{type:1}}">《注册协议》</router-link>
&lt;!&ndash;              <router-link :to="{name:'Protocol',params:{type:3}}">《合格投资人申明》</router-link>&ndash;&gt;
              <router-link style="margin-left: 10px;margin-top: 10px;" :to="{name:'Protocol',params:{type:2}}">《风险揭示书》</router-link>

            </div>
            <button class="register_btn" @click="register">立即注册</button>
          </div>-->
          <el-card class="box-card" style="height: 100%">
            <!-- <div slot="header" class="clearfix">
              <span style="color: #E6A23C;display:none;">新用户注册</span>
              <div>
                <p style="text-align:center;font-size: 19px;color:red"><span>新会员最高专享礼</span></p><br>
                             <p style="text-align:center">~最高可领~</p>
                <p style="text-align:center">注册送<span style="color:red">{{sys_give_voucher_amount}}元</span>+首充<span style="color:red">10000元</span></p>
                <p style="padding-top: 22px;color:red;text-align:center">豪礼一：新用户注册送{{sys_give_voucher_amount}}元</p>
                             <p style="text-align:center">注册<span style="color:red">&nbsp;<b>{{sys_give_voucher_amount}}</b>&nbsp;元</span>&nbsp;+&nbsp;首充礼品<span style="color:red">&nbsp;<b>10000</b>&nbsp;元</span>&nbsp;+&nbsp;交易红包<span style="color:red">&nbsp;<b>9999</b>&nbsp;元</span></p>
                              <p style="padding-top: 22px;color:red;text-align:center">豪礼一：新用户注册送&nbsp;<b>{{sys_give_voucher_amount}}</b>&nbsp;元</p>
              </div>
            </div> -->
            <div class="content">
              <el-form ref="form" id="registerForm" class="space">
                <el-form-item>
                  <el-input maxlength="11" v-model.number="reName" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input show-password v-model="rePass" placeholder="请输入登录密码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="rePicCode" placeholder="请输入图形验证码"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <img :src="captcha" class="login_img" height="150" width="40" @click="this.getCaptcha">
                      <!--                      <s-identify :identifyCode="identifyCode" class="login_img"
                                                        :contentWidth="150"
                                                        :contentHeight="40"
                                                        @refreshcode="getRePicCode"></s-identify>-->
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="rePhoneCode" placeholder="请输入短信验证码"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <el-button type="info" @click="getPhoneCode" :disabled="disabled" style="width: 100%">{{phoneCodeText}}</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="rePhone" placeholder="请输入推荐码(选填)"></el-input>
                </el-form-item>
                <el-form-item style="margin: 0">
                  <el-checkbox v-model="reAgree">我同意</el-checkbox><router-link :to="{name:'Protocol',params:{type:1}}">《注册协议》</router-link><router-link :to="{name:'Protocol',params:{type:2}}">《风险揭示书》</router-link>
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" style="width: 100%" @click="register">立即创建</el-button>
                </el-form-item>
              </el-form>
            </div>

          </el-card>
        </div>
      </div>
    </div>
    <!--<div class="login_box">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>卡片名称</span>
          <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>
        </div>
        <div v-for="o in 4" :key="o" class="text item">
          {{'列表内容 ' + o }}
        </div>
      </el-card>
    </div>-->
    <el-dialog id="registerSuccessPopup" :visible.sync="isRegisterSuccess">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <p style="text-align:center; font-size: 17px">您已注册成功</p>
          <p style="text-align:center; font-size: 17px;margin-top:15px;">请登录领取<span>&nbsp;{{sys_give_voucher_amount}}&nbsp;</span>元礼金</p>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="cancel()">取消</el-button>
        <el-button type="primary" @click="login()">立即登录</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import $ from "jquery";
import SIdentify from "../components/icode";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "Register",
  components: {
    SIdentify
  },
  data() {
    return {
      reName: "", //注册_账号
      rePass: "", //注册_密码
      rePicCode: "", //注册_图形验证码
      identifyCode: "", //注册_图形验证码图片
      identifyCodes: "123456789",
      rePhoneCode: "", //注册_短信验证码
      rePhone: "", //注册_邀请人手机号
      reAgree: true, //注册_注册协议 false：不同意 true：同意
      phoneCodeText: "获取验证码",
      disabled: false,
      isRegisterSuccess: false,
      sys_give_voucher_amount: "",
      captcha:'',
      verify_token:''
    };
  },
  created() {
    // this.getCaptcha();
  },
  mounted: function() {
//     const urlParams = new URLSearchParams(window.location.search);
// const myParam = urlParams.get('code');
//     console.log("myParam",myParam)
//     var foo = getParameterByName('code');
//     console.log("efgrerg",foo)
    // console.log("rtgreger",this.$router.history.current.query.code)
    this.rePhone = localStorage.getItem('reCouponCode');
    this.rePhone = this.$router.history.current.query.code;



    this.realNameConfig();
    //获取图片验证码
    // this.getRePicCode();
    this.get_rePhone();
    this.getCaptcha();
    // $("#wrapper").css("background", "#737373");
    /*$("body,html").css({ overflow: "inherit", height: "100%" });
    var canvas = document.getElementById("canvas");
    // var ctx = canvas.getContext("2d");
    // var w = (canvas.width = window.innerWidth);
    // var h = (canvas.height = window.innerHeight);
    var hue = 217;
    var stars = [];
    var count = 0;
    var maxStars = 500;
    var canvas2 = document.createElement("canvas");
    var ctx2 = canvas2.getContext("2d");
    canvas2.width = 100;
    canvas2.height = 100;
    var half = canvas2.width / 2;
    var gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half);
    gradient2.addColorStop(0.025, "#eee");
    gradient2.addColorStop(0.1, "hsl(" + hue + ", 61%, 33%)");
    gradient2.addColorStop(0.25, "hsl(" + hue + ", 64%, 6%)");
    gradient2.addColorStop(1, "transparent");
    ctx2.fillStyle = gradient2;
    ctx2.beginPath();
    ctx2.arc(half, half, half, 0, Math.PI * 2);
    ctx2.fill();*/

    /*function random(b, a) {
      if (arguments.length < 2) {
        a = b;
        b = 0;
      }
      if (b > a) {
        var c = a;
        a = b;
        b = c;
      }
      return Math.floor(Math.random() * (a - b + 1)) + b;
    }

    function maxOrbit(b, d) {
      var a = Math.max(b, d),
        c = Math.round(Math.sqrt(a * a + a * a));
      return c / 2;
    }
    var Star = function() {
      this.orbitRadius = random(maxOrbit(w, h));
      this.radius = random(60, this.orbitRadius) / 8;
      this.orbitX = w / 2;
      this.orbitY = h / 2;
      this.timePassed = random(0, maxStars);
      this.speed = random(this.orbitRadius) / 80000;
      this.alpha = random(2, 10) / 10;
      count++;
      stars[count] = this;
    };
    Star.prototype.draw = function() {
      var a = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
        c = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
        b = random(10);
      if (b === 1 && this.alpha > 0) {
        this.alpha -= 0.05;
      } else {
        if (b === 2 && this.alpha < 1) {
          this.alpha += 0.05;
        }
      }
      ctx.globalAlpha = this.alpha;
      ctx.drawImage(
        canvas2,
        a - this.radius / 2,
        c - this.radius / 2,
        this.radius,
        this.radius
      );
      this.timePassed += this.speed;
    };
    for (var i = 0; i < maxStars; i++) {
      new Star();
    }

    function animation() {
      ctx.globalCompositeOperation = "source-over";
      ctx.globalAlpha = 0.5;
      ctx.fillStyle = "#023164";
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = "lighter";
      for (var b = 1, a = stars.length; b < a; b++) {
        stars[b].draw();
      }
      window.requestAnimationFrame(animation);
    }
    animation();*/
  },
  methods: {
    realNameConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name:"sys_give_voucher_amount"
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            //first time Recharge
            that.sys_give_voucher_amount = res.data.data;
            // that.isFirstTimeTrading = false;
            // localStorage.setItem("isFirstTimeRecharge", false);
          } else {
            // that.isFirstTimeTrading = true;
            // localStorage.setItem("isFirstTimeRecharge", true);

          }
        });
    },
    getCaptcha(){
      let that = this;
      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "getSmsPic",
        },
      })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha = resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$message.error(res.data.msg);
          }
        });
      // this.captcha = 'https://server.hk9999z.com/captcha?v='+Math.random();
    },
    getPhoneCode() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.reName)) {
        that.$message.error("手机号格式不正确");
      } else {

        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.reName.toString();
        let phoneNumber = that.encryptMessage(userPhone, publicKey);
        that.disabled = true;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "register_code_e",
            phone: phoneNumber,
            rePicCode: that.rePicCode,
            verify_token:that.verify_token
          },
        })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success"
              });
              var time = 60;
              that.phoneCodeText = time + "s";
              var timer1 = setInterval(function() {
                time--;
                that.phoneCodeText = time + "s";
                if (time <= 0) {
                  that.phoneCodeText = "获取验证码";
                  that.disabled = false;
                  clearInterval(timer1);
                }
              }, 1000);
            } else if (res.data.code == 0) {
              that.disabled = false;
              that.$message.error(res.data.msg);
              that.getCaptcha();
            }
          });
      }
    },
    goLogin() {
      this.$router.push({
        path: "/login"
      });
    },
    //获取注册 图片验证码
    getRePicCode() {
      // this.rePicCode = "";
      // this.identifyCode = "";
      // this.makeCode(this.identifyCodes, 4);
    },
    // 生成一个随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //更新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    //创建图形验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
          ];
      }
    },
    register() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.reName)) {
        that.$message.error("手机号格式不正确");
      } else if (that.rePass == "") {
        that.$message.error("请输入登录密码");
      }  else if (that.rePhoneCode == "") {
        that.$message.error("请输入短信验证码");
      }  else if (that.reAgree == false) {
        that.$message.error("请同意注册协议");
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "register",
              phone: that.reName,
              password: that.rePass,
              code: that.rePhoneCode,
              reid: that.rePhone
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.realNameConfig();
              that.isRegisterSuccess = true;
              // that.$message({
              //   message: res.data.msg,
              //   type: "success",
              //   onClose:function () {
              //     that.$router.push('/login')
              //   }
              // });
              // that.isRegisterSuccess();

            } else if (res.data.code == 0) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    get_rePhone(){
      let that = this;
      let code = this.$route.query.code;
      let rePhone = window.sessionStorage.getItem("rePhone");

      if (!code  && !rePhone ){

        that.rePhone = '';


        // that.rePhone = code;
      }else{
        if (!code == false){
          that.rePhone = code;
          window.sessionStorage.setItem("rePhone", code);
        }else if (!rePhone == false){
          that.rePhone = rePhone;
          window.sessionStorage.setItem("rePhone", rePhone);
        }
      }
    },
    cancel() {
      this.isRegisterSuccess = false;
    },
    login() {
      this.$router.push({
        name:"Login"
      })
    }
  }
};
</script>
<style scoped>
@import url("./../assets/css/login.css");
.picCode {
  display: inline-block;
  width: 97px;
  height: 41px;
  position: absolute;
  right: 78px;
  top: 253px;
}
.content{
  width: 80%;
  margin: 0 auto;
  /*text-align: center;*/
}

.space {
  margin-top: 68px;
}

</style>
<style>
#registerForm .el-form-item{
  margin-bottom: 11px;
}
#registerSuccessPopup .el-dialog__body {
  padding: 0px;
}
#registerSuccessPopup .el-form-item__content {
  margin-left: 0px !important;
}
#registerSuccessPopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue